/** Imperative widgets and separate React roots must resolve ownership from their DOM anchor. */
export function getOverlayPortalTarget(anchor: Element): HTMLElement {
  return (
    anchor
      .closest("[data-overlay-id]")
      ?.querySelector<HTMLElement>(":scope > [data-overlay-floating-root]") ??
    anchor.ownerDocument.body
  );
}

export function isGlobalToastTarget(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest("[data-global-toast-root]") != null;
}
